import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-date-range-dialog',
  templateUrl: './date-range-dialog.component.html',
  styleUrls: ['./date-range-dialog.component.scss']
})
export class DateRangeDialogComponent implements OnInit {
  from: string;
  to: string;

  constructor(private _dialogRef: MdDialogRef<DateRangeDialogComponent>) { }

  ngOnInit() {

    let today = new Date();
    if (!this.to) {
      this.to = today.toISOString().substr(0, 10);
    }
    if (!this.from) {
      today.setMonth(today.getMonth() - 1);
      this.from = today.toISOString().substr(0, 10);
    }
  }

  close(result: { from: string, to: string }) {
    this._dialogRef.close(result);
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/date-range-dialog/date-range-dialog.component.ts